import { createAction } from '@reduxjs/toolkit';

export const FETCH_GREETINGS_ACTION_TYPE = 'saga/fetchGreetings';
export const fetchGreetingsAction = createAction(FETCH_GREETINGS_ACTION_TYPE);
